
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { TextFilter } from "../../../../components/Form/FormStyles";
import { formatCarbonCreditTypes } from "../../../PlantingProjectEditor/Carbon/CarbonCreditType";

export function CarbonCreditTypeHeader() {
	return (
		<StickyHeader
			style={{
				...offsetOneRow,
				width: '200px',
				minWidth: '200px',
				maxWidth: '200px'
			}}>
			Carbon Credit Type
		</StickyHeader>
	)
}

export function CarbonCreditTypeFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={
						filter?.CarbonCreditCreditTypeValidated ??
						ValidateFilterValue.Unset
					}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonCreditCreditTypeValidated: e.value
						})
					}
				/>
				<TextFilter
					value={filter?.CarbonCreditCreditType ?? ''}
					onChange={(e) =>
						updateFilter({
							...filter,
							CarbonCreditCreditType: e.target.value
						})
					}
				/>
			</CellWithValidator>
		</StickyHeader>
	)
}

export function CarbonCreditTypeContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>
					{ppn.PlantingProject.CarbonCreditCreditTypeValidated && (
						<ValidatedIcon />
					)}
				</span>
				<span>
					{formatCarbonCreditTypes(
						ppn.PlantingProject.CarbonCreditCreditType
					)}
				</span>
			</CellWithValidator>
		</StateStyledCell>
	)
}